import type React from 'react'

import { cn } from '@/lib/cn'

import { Separator } from '../separator'

const Paper = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <section
    className={cn(
      'flex flex-col items-start justify-center bg-white rounded-lg border w-full border-system-border-secondary',
      className,
    )}
    {...props}
  />
)
Paper.displayName = 'Paper'

const PaperHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadElement>) => (
  <header
    className={cn('flex flex-col p-6 gap-3 pb-2 w-full ', className)}
    {...props}
  />
)
PaperHeader.displayName = 'PaperHeader'

const PaperTitle = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h6
    className={cn(
      'font-montserrat font-bold text-xl text-system-primary-purple',
      className,
    )}
    {...props}
  />
)
PaperTitle.displayName = 'PaperTitle'

const PaperSubtitle = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-system-text-secondary', className)} {...props} />
)
PaperSubtitle.displayName = 'PaperSubtitle'

const PaperFooter = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <footer
    className={cn('flex flex-col gap-3 py-3 w-full', className)}
    {...props}
  >
    <Separator className="w-full" />
    <div className="flex w-full flex-col gap-3 px-6 md:flex-row md:items-center md:justify-between">
      {children}
    </div>
  </footer>
)
PaperFooter.displayName = 'PaperFooter'

export { Paper, PaperHeader, PaperTitle, PaperSubtitle, PaperFooter }
